<template>
<div class="latest-featured-searches">
    <div class="featured-searches-heading">
        <h3>Featured Review Searches</h3>
    </div>
    <div class="fact-check-items-container">
        <template v-for="(item, index) in featured_fc_searches_display" >
            <div class="featured-search" :key="`${item.id}-${index}`"
                v-if="index < featured_searches_display_limit || all_featured_visible == true" >
                    <div class="featured-search-title" >
                        <a :href="factCheckUrl+'?featId='+item.id" v-text="item.title" ></a>
                    </div>
                    <div class="featured-search-description" >
                        {{ item.description.substring(0, 120) }}
                    </div>
            </div>
        </template>
    </div>
    <div class="archive_button">
        <a href="/fact_check_review/featured/">More Featured Searches →</a>
    </div>
</div>
</template>

<script>

import ApiMixin from './ApiMixin.js';

export default {
    name: "fc-featured-searches",
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            featured_fc_searches_display: [],
            factCheckUrl: 'https://www.realclearpolitics.com/fact_check_review/',
            all_featured_visible: false,
        };
    },
    created(){
        this.loadData();
    },
    computed: {
        /**
         * If window width is bigger than 767 and smaller than 1024 
         * display 4 featured fc searches instead of 3 so it looks better
         */
        featured_searches_display_limit: function(){
  
          if(this.window_width > 767 && this.window_width < 1024){
            return 4;
          }
  
          return 3;
        },
    },
    methods: {
        loadData(){
            jsonp(this.data_sources.featured_fact_checks+'?v='+this.cache_buster(), {name: "jsonCallback"}, (err, data) => {
                if (err) {
                    console.error("error loading featured searches", err.message);
                } else {
                    console.log("featured searches", data);

                    this.featured_fc_searches_display = this.getRandomFeaturedFactChecks(4, data);
                }
            });
        },
    },
};
</script>